import {Component} from '@angular/core';

@Component({
    selector: 'kkk-error-404',
    templateUrl: './error-404.component.html',
    styleUrls: ['./error-404.component.scss']
})
export class Error404Component {
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/error-404/error-404.component.ts